import { useEffect, useState, useRef } from 'react';

// Mount once at the app root, alongside EditAccessToastHost. Listens for the
// 'sw-update-ready' window event fired by serviceWorkerRegistration.js when a
// new build has installed and taken over from a previous one. Shows a small
// non-blocking banner rather than reloading automatically — staff may be
// mid-scan or mid-photo-capture on a warehouse scanner, and an unannounced
// reload would interrupt that. A second tap is required to actually reload
// (same "press again to confirm" pattern already used by the scan screen's
// back button in SoWarehouseScan.jsx), so a single mis-tap costs nothing.
export function UpdateBannerHost() {
    const [ready, setReady] = useState(false);
    const [confirming, setConfirming] = useState(false);
    const confirmTimerRef = useRef(null);

    useEffect(() => {
        const handler = () => setReady(true);
        window.addEventListener('sw-update-ready', handler);
        return () => {
            window.removeEventListener('sw-update-ready', handler);
            clearTimeout(confirmTimerRef.current);
        };
    }, []);

    if (!ready) return null;

    function handleTap() {
        if (confirming) {
            window.location.reload();
            return;
        }
        setConfirming(true);
        confirmTimerRef.current = setTimeout(() => setConfirming(false), 4000);
    }

    return (
        <div style={S.wrap} onClick={handleTap}>
            <div style={S.banner}>
                {confirming ? 'Tap again to refresh now' : 'Update available — tap to refresh'}
            </div>
        </div>
    );
}

const S = {
    wrap: {
        position: 'fixed', bottom: 16, left: '50%', transform: 'translateX(-50%)',
        zIndex: 9999, cursor: 'pointer',
    },
    banner: {
        background: '#3A2A45', color: '#fff', padding: '12px 20px', borderRadius: 10,
        fontSize: 13.5, fontWeight: 600, fontFamily: "'Poppins', sans-serif",
        boxShadow: '0 8px 24px rgba(0,0,0,0.25)', maxWidth: 320, textAlign: 'center',
    },
};
